


export default class Claim {
  constructor(
    typeId, 
    claimDate,
    cost, 
    atFault, 
    injuryInvolved, 
    objectId,
    claimDetailsId,
    theftFromHome , 
    statusId, 
    ncdAffected , 
    incurredOnPolicy, 
    referenceNumber, 
    parentObjectId , 
    parentObjectHistoryId
  ) {
    this.typeId = typeId;
    this.claimDate = claimDate;
    this.cost = cost;
    this.atFault = atFault;
    this.injuryInvolved = injuryInvolved;
    this.objectId = objectId;
    this.claimDetailsId = claimDetailsId;
    this.theftFromHome = theftFromHome;
    this.statusId = statusId;
    this.ncdAffected = ncdAffected;
    this.incurredOnPolicy = incurredOnPolicy;
    this.referenceNumber = referenceNumber;
    this.parentObjectId = parentObjectId;
    this.parentObjectHistoryId = parentObjectHistoryId;
  }
}

